import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { inject } from '@angular/core';
import { AppContextServiceService } from '../services/app-context-service.service';
import { firstValueFrom, filter } from 'rxjs';

export const authGuard: CanActivateFn = async (route, state) => {
  const appContextService = inject(AppContextServiceService);
  const router = inject(Router);

  // Wait until authedUser emits a non-undefined value (true or false)
  const authedUser = await firstValueFrom(
    appContextService.authedUser$.pipe(
      filter((val) => val !== undefined && val !== null)
    )
  );

  if (authedUser) {
    return true;
  } else {
    return router.createUrlTree(['/login']);
  }
};
